import studentHighlightsService from '../../services/StudentHighlightsService';
import timeReader from '../../store/readHelpers/TimeReader';
import uiService from '../../services/UIService';
import routeTypes from '../../constants/RouteTypes';
import remoteOralExamService from '../../services/RemoteOralExamService';
import utilService from '../../services/UtilService';
import assessmentReader from '../../store/readHelpers/AssessmentReader';
import questionReader from '../../store/readHelpers/QuestionReader';

const appMainScreenSelector = {
    selectIsCurrentWordFormationQuestion(questionId) {
        if (!questionId) {
            return false;
        }

        const currentQuestion = assessmentReader.getQuestion(questionId);
        return !!currentQuestion && questionReader.isWordFormationQuestion(currentQuestion);
    },

    selectProps(state) {
        const {
            assessment,
            currentlyShown: { routeType, questionId },
            remoteOralExam,
            session: { mode, viewMedia, context } } = state;
        const hasAssessment = utilService.isObjectWithProps(assessment);
        const showHeader = uiService.showHeader(routeType, mode, viewMedia, context);
        const timeHasExpired = timeReader.timeHasExpired();

        return {
            addAppWrapper: routeType === routeTypes.ROUTE_TYPE_OPTIONS,
            isNoteTakingAndHighlightingEnabled: studentHighlightsService.isNoteTakingAndHighlightingEnabled(),
            isCurrentWordFormationQuestion: this.selectIsCurrentWordFormationQuestion(questionId),
            showAdditionalResourcesBar: uiService.showAdditionalResourcesBar(routeType, mode, viewMedia, context, timeHasExpired, hasAssessment),
            showAnnotationsSidebar: uiService.showAnnotationsSidebar(),
            showChatSidebar: showHeader && uiService.showChatSidebar(),
            showFooter: uiService.showFooter(routeType, mode, viewMedia, context, timeHasExpired, hasAssessment),
            showHeader,
            showZoomCall: remoteOralExamService.showZoomCall(remoteOralExam, routeType),
        };
    },
};

export default appMainScreenSelector;
